import React, { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { fmtDate, labelize } from "@/lib/constants";

export default function AuditLog() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  const [total, setTotal] = useState(0);

  const load = useCallback(async () => {
    const p = new URLSearchParams();
    if (q) p.set("q", q);
    p.set("limit", "200");
    const { data } = await api.get(`/audit?${p}`);
    setRows(data.audit);
    setTotal(data.total);
  }, [q]);

  // Initial load only — subsequent filter changes go through the Apply button.
  useEffect(() => { load(); }, []);

  return (
    <div>
      <div className="label-mono">Compliance</div>
      <h1 className="font-chivo font-black text-4xl md:text-5xl uppercase tracking-tighter leading-none">Audit log</h1>

      <div className="brut-card mt-4 p-4 flex gap-2">
        <input data-testid="audit-search" placeholder="Search action, actor, target ID"
          value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && load()}
          className="flex-1 border border-black px-3 py-2" />
        <button onClick={load} className="border border-black px-3 py-2 text-xs uppercase tracking-widest hover:bg-black hover:text-white transition-colors duration-100">Apply</button>
      </div>

      <div className="brut-card mt-4 overflow-x-auto">
        <div className="px-4 py-2 border-b border-black label-mono">{rows.length} shown · {total} total</div>
        <table className="w-full text-sm font-mono min-w-[900px]">
          <thead>
            <tr className="border-b border-black text-[10px] uppercase tracking-widest">
              <th className="py-2 px-4 text-left">When</th>
              <th className="py-2 px-4 text-left">Action</th>
              <th className="py-2 px-4 text-left">Actor</th>
              <th className="py-2 px-4 text-left">Target</th>
              <th className="py-2 px-4 text-left">IP</th>
              <th className="py-2 px-4 text-left">Notes</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} className="border-b border-zinc-200" data-testid={`audit-row-${r.id}`}>
                <td className="py-2 px-4 text-[11px]">{fmtDate(r.created_at)}</td>
                <td className="py-2 px-4">{labelize(r.action)}</td>
                <td className="py-2 px-4">{r.actor_name || "—"}<br /><span className="text-zinc-500">{r.actor_email}</span></td>
                <td className="py-2 px-4">{r.target_type}<br /><span className="text-zinc-500 text-[11px]">{r.target_id?.slice(0, 12)}</span></td>
                <td className="py-2 px-4">{r.ip_address || "—"}</td>
                <td className="py-2 px-4 max-w-[300px] truncate">{r.notes || "—"}</td>
              </tr>
            ))}
            {!rows.length && <tr><td colSpan={6} className="py-6 text-center label-mono">No audit entries</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
